var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        name: "quote-request-modal",
        width: "100%",
        height: "100%",
        clickToClose: false,
      },
    },
    [_c("QuoteContainer", { on: { onBack: _vm.closeModal } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }